import { qq, q } from "../../helper/q"

export const profileQuestionInit = () => {
  const messages = qq(".profileMessageSection")
  messages.map(message => {
    if (q(".referenceQuestionButton", message)) {
      if (!q(".referenceQuestionButton", message).dataset.event) {
        q(".referenceQuestionButton", message).dataset.event = true
        q(".referenceQuestionButton", message).addEventListener("click", () => {
          q(".referenceQuestionButton", message).classList.toggle("referenceQuestionButtonActive")
          q(".referenceAnswers", message).classList.toggle("referenceAnswersHidden")
        })
      }
    }
  })
}
